import type { ImportedPartBodyTopologyAsset } from '../loaders/types'

/**
 * 解析导入 body 在 pick host / 拓扑代理上应使用的权威 objectId。
 *
 * 设计说明：
 * 1. Worker GeometryState 中的 `geometryObjectId` 才是修改型特征应命中的目标 ID；
 * 2. topo sidecar 的 `meshData.metadata.objectId` 与 `bodyBindingId` 仅作为 hydration 前或 legacy 数据的回退；
 * 3. 该函数只回答“当前 body 拓扑资产应暴露哪个 objectId”，不访问场景或 Worker 状态。
 *
 * @param topologyAsset 导入 body 级拓扑资产。
 * @returns pick host 与 FeatureFace/Line/Point 代理应使用的 objectId。
 */
export function resolveImportedPickHostObjectId(
  topologyAsset: ImportedPartBodyTopologyAsset,
): string {
  const geometryObjectId = topologyAsset.geometryObjectId?.trim() ?? ''
  if (geometryObjectId.length > 0) {
    return geometryObjectId
  }

  const metadataObjectId = topologyAsset.meshData.metadata?.objectId
  if (typeof metadataObjectId === 'string' && metadataObjectId.trim().length > 0) {
    return metadataObjectId.trim()
  }

  const meshDataId = topologyAsset.meshData.id?.trim() ?? ''
  if (meshDataId.length > 0) {
    return meshDataId
  }

  return topologyAsset.bodyBindingId
}
